import { render, staticRenderFns } from "./card-base-template.vue?vue&type=template&id=7d0b61f6&scoped=true"
import script from "./card-base-template.vue?vue&type=script&lang=js"
export * from "./card-base-template.vue?vue&type=script&lang=js"
import style0 from "./card-base-template.vue?vue&type=style&index=0&id=7d0b61f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0b61f6",
  null
  
)

export default component.exports